import type { ClientBasedAuth } from '@atlaskit/media-core';
import { ObjectRecorder } from '../src/ObjectRecorder';

export const mediaConfigRecorder = new ObjectRecorder<ClientBasedAuth>();
export const mediaConfigEnforceDSPRecorder = new ObjectRecorder<boolean>();
